'use client';

var ECVOption;
(function (ECVOption) {
    ECVOption["onlineProfile"] = "onlineProfile";
    ECVOption["attachedCV"] = "attachedCV";
})(ECVOption || (ECVOption = {}));
var EEditAction;
(function (EEditAction) {
    EEditAction["editPhone"] = "editPhone";
    EEditAction["editJobTitle"] = "editJobTitle";
    EEditAction["none"] = "none";
})(EEditAction || (EEditAction = {}));
var DEFAULT_ALLOW_FILES_EXT = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
];
var DEFAULT_ALLOW_EXT = '.doc,.docx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf';
var DEFAULT_LIMIT_FILE_SIZE = 5120000; // 5MB
var DEFAULT_SUCCESS_CODE = 200;
var EUserInfoType;
(function (EUserInfoType) {
    EUserInfoType["phone"] = "phone";
    EUserInfoType["jobTitle"] = "jobTitle";
})(EUserInfoType || (EUserInfoType = {}));
var EApplyType;
(function (EApplyType) {
    EApplyType["online"] = "online";
    EApplyType["lastAttachment"] = "last_attachment";
    EApplyType["newAttachment"] = "new_attachment";
})(EApplyType || (EApplyType = {}));
var EBlockSuggestion;
(function (EBlockSuggestion) {
    EBlockSuggestion["BasicInfo"] = "BasicInfo";
    EBlockSuggestion["Skills"] = "Skills";
    EBlockSuggestion["Educations"] = "Educations";
    EBlockSuggestion["WorkingHistories"] = "WorkingHistories";
    EBlockSuggestion["Summary"] = "Summary";
})(EBlockSuggestion || (EBlockSuggestion = {}));

export { DEFAULT_ALLOW_EXT, DEFAULT_ALLOW_FILES_EXT, DEFAULT_LIMIT_FILE_SIZE, DEFAULT_SUCCESS_CODE, EApplyType, EBlockSuggestion, ECVOption, EEditAction, EUserInfoType };
//# sourceMappingURL=type.js.map
